import { render, staticRenderFns } from "./page_keys.vue?vue&type=template&id=c3aa19b2&scoped=true&"
import script from "./page_keys.vue?vue&type=script&lang=js&"
export * from "./page_keys.vue?vue&type=script&lang=js&"
import style0 from "./page_keys.vue?vue&type=style&index=0&id=c3aa19b2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aa19b2",
  null
  
)

export default component.exports